//libs
import { styled } from '@nykaa/ui-components';

//components
import Chips from '@nykaa/ui-components/Chips';
import Button from '@nykaa/ui-components/Button';

export const Container = styled.div<{ isCollapsed: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing40};
  ${({ isCollapsed }) => (isCollapsed ? ' height: min-content' : 'flex-wrap: wrap')}
`;

export const SelectedFilter = styled(Chips)`
  width: max-content;
`;

export const TrailingIcon = styled(Button)`
  padding: ${({ theme }) => theme.spacing.spacing40};
  border-radius: ${({ theme }) => theme.borders.radius10};
  height: min-content;
`;
export const ColorCircle = styled.div<{ colorCode: string }>`
  width: 16px;
  height: 16px;
  ${({ colorCode }) => colorCode && `background-color:${colorCode}`};
  border-radius: ${({ theme }) => theme.borders.radius60};
`;
export const ColorImage = ColorCircle.withComponent('img');
